import { Component, ViewEncapsulation } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { environment } from 'environments/environment';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../_services';
import Swal from 'sweetalert2'
import { Broadcaster } from 'environments/broadcaster';

import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';//added by kuldeep on 10-03-2018
import {MomentDateAdapter} from '@angular/material-moment-adapter';//added by kuldeep on 10-03-2018
import * as _moment from 'moment'; //added by kuldeep on 10-03-2018
import * as _rollupMoment from 'moment';//added by kuldeep on 10-03-2018
 
const moment = _rollupMoment || _moment;
import { LoaderService } from '../../../_services/loader.service';
import { process, State } from '@progress/kendo-data-query';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { GroupDescriptor } from '@progress/kendo-data-query';
import { SelectableSettings } from '@progress/kendo-angular-grid';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

declare var $: any;


const distinctBanks = data => data
  .filter((x, idx, xs) => xs.findIndex(y => y.zone === x.zone) === idx);

@Component({
  selector: 'app-bankmst',
  templateUrl: './bankmst.component.html',
  styleUrls: ['./bankmst.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class BankmstComponent {
  prjId: any
  public bankLists: any[];
  showLoader: boolean;
  dataRangeModal: any;
  userId:any

  public state: State = {
    skip: 0,
    take: 100,
    // Initial filter descriptor
    filter: {
      logic: 'and',
      filters: []
    }
  };
  public pageSize: any
  public checkboxOnly = false;
  public mode = 'multiple';
  public selectableSettings: SelectableSettings;
  public distinctBanks: any[]
  public distinctWard: any[]

  public groups: GroupDescriptor[] = [];
  public view: Observable<GridDataResult>;
  public gridDataBanks: any;
  public hiddenColumns: string[] = [];
  bankName: any;
  public isHidden(columnName: string): boolean {
    return this.hiddenColumns.indexOf(columnName) > -1;
  }

  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups;
    this.loadProducts();
  }

  private loadProducts(): void {
    this.gridDataBanks = process(this.bankLists, { group: this.groups });
  }

  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.bankLists
    };
    return result;
  }


  constructor(private sanitizer: DomSanitizer ,private broadcaster: Broadcaster, private auth: AuthService, private http : HttpClient , private routes: ActivatedRoute, private router: Router, private loaderService: LoaderService) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });
    this.allData = this.allData.bind(this);
  }


  getBanks() {
    this.loaderService.display(true);
    this.http.get(environment.apiUrl + 'bankMaster').subscribe(data => {
      var result:any
      result = data
      this.bankLists = result
      this.distinctBanks = distinctBanks(this.bankLists);
      this.gridDataBanks = process(this.bankLists, this.state);
      this.loaderService.display(false);
    });
  }


  addBanksModal() {
    this.bankName = null
    $("#addBanksModal").modal("show")
  }

  addNewBank(){
    this.loaderService.display(true);
    if(this.bankName == null){
      Swal({
        type: 'error',
        title: 'Oops...',
        text: 'Please Enter A Bank Name'
      })
    }
    var data = {
      bankName:this.bankName,
    }
    this.http.post(environment.apiUrl + 'bankMaster',data).subscribe(data => {
      var result:any
        result  = data
        var successText = 'Bank is added successfully'
        if(result.status == 'OK'){
          $("#addBanksModal").modal("hide")
          Swal({
            type: 'success',
            title: '',
            text: successText,
          })
          this.getBanks();
        }else{
          Swal({
            type: 'error',
            title: 'Oops...',
            text: 'Some Internal Problem',
          })
          this.getBanks();
        }
      this.loaderService.display(false);
    });

  }

  ngOnInit() {
    this.prjId = this.auth.getAuthentication().projectId
    this.userId = this.auth.getAuthentication().id
    this.getBanks()
  }











}





// WEBPACK FOOTER //
// ./src/app/crm/kcc/bankmst/bankmst.component.ts